<template>
    <div class="right-container">
        <p class="right-h2">关于切图</p>
        <p class="right-h3">切图软件</p>
        <p class="right-content">一般项目的设计稿都是在蓝湖上的。但是也会有特殊情况，导致设计师把PSD源文件设计稿发给了你。如果在这种情况下我们直接用ps来进行切图的话会很麻烦，这会大大降低切图的效率。所以我们就需要用到切图软件来进行辅助。</p>
        <p class="right-content">PxCook是高效易用的自动标注工具。使用方法也很简单，只需要先创建一个项目，然后把PSD源文件拉到项目里面就可以了。 <a href="https://fancynode.com.cn/pxcook" target="_blank">点击下载</a></p>
        <img src="../../assets/img/img2.jpg">
        <p class="right-h3">切图文件</p>
        <p class="right-content">普通项目的文件结构如下图所示。</p>
        <ul>
            <li>css：存放.css文件</li>
            <li>img：存放图片文件</li>
            <li>js：存放.js文件</li>
            <li>font：存放字体文件</li>
            <li>scss：存放.scss文件（如果用的是less就改成less）</li>
            <li>plugins：存放第三方插件，比如swiper，layer...</li>
        </ul>
        <img class="inline img1" src="../../assets/img/img3.png">
        <img class="inline img1" src="../../assets/img/img4.png">
        <p class="right-content">html文件名需语义化，比如about.html，news.html。多单词文件名用下划线进行连接，比如news_detail.html。</p>
        <p class="right-h3">切图注意事项</p>
        <p class="right-content">在有设计稿的情况下，切图一定要还原设计稿的样子，不管是字体，颜色还是间距都要跟设计稿一样。而在此之前字体的行高（<code>line-height</code>）是需要特别注意的。</p>
        <p class="right-content"><code>line-height</code>：用于设置多行元素的空间量，如多行文本的间距。因为行高一般用在文本上，所以简单来说行高就是设置文字的高度，详情可以看这篇文章 <a target="_blank" href="https://zhuanlan.zhihu.com/p/352965852?utm_id=0">line-height总结</a>。<code>line-height</code>的默认值为 <code>normal</code> ，而 <code>normal</code> 在不同的浏览器上有不同的显示效果，因为 <code>normal</code> 的值大概在1.2到1.5之间，Chrome浏览器大概在1.3左右。也就是说在Chrome浏览器上一个font-size为16px的文字，它的行高是16px*1.3≈21px。这会产生一个问题，就是在调整间距的时候如果不设置 <code>line-height</code> 的默认值，那么我们就需要计算出行高再去调整间距，这样就会变得繁琐，而且每个浏览器的 <code>line-height</code> 的倍数还是不一样的。</p>
        <p class="right-content">对于行高不熟悉的建议将 <code>line-height</code> 设置为1，即1倍行高。因为不管是蓝湖还是PxCook测量文字与周围元素的间距都是以文字行高为1倍来得出数据的，这样可以快速调整间距，同时也方便后期修改。</p>
        <p class="right-content">当然，如果在切图时觉得 <code>line-height</code> 设为1会增加项目的难度，那么也可以设置自己习惯的倍数，比如1.3，1.5等等。</p>
        <div class="right-code">
            <pre>
                <code class="language-css line-numbers" v-html="code.cut1"></code>
            </pre>
        </div>
        <p class="right-content">同时还需要注意一下几点：</p>
        <ul>
            <li>详情页的内容区域需要将它的父元素设置为 <code>line-height: normal</code>：因为详情页的内容区域里面的内容是由后台富文本编辑器生成的，所以为了防止我们自己设置的行高对这个区域的行高产生不必要的影响，我们需要用一个元素把详情页的内容区域包裹起来，然后设置 <code>line-height</code> 为 <code>normal</code></li>
            <li>如果一个文本有超出显示省略号的效果，那么 <code>line-height</code> 不能设置为1：其实从广义上来讲，只要一个文本元素设有 <code>overflow: hidden;</code> 属性，那么这个元素就不适合设置 <code>line-height</code> 为1了，因为这可能会把文本的某一部分给隐藏，导致显示不全。</li>
        </ul>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: 'cut',
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>
.img1{
    width: 200px;
    height: 309px;
    margin-top: 20px;
    margin-right: 40px;
}
</style>